// import React, { useEffect, useState } from "react";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import autoTable from "jspdf-autotable";
// import AddCustomerPopup from "./AddCustomerPopup";
// import "../Style/InvoiceForm.css";
// import "../Style/Common.css";
// import "../Style/AddCustomerPopup.css";
// import { getUsers } from "../Services/userService";
// import { getOrganizationDetails } from "../Services/orgService";
// import {
//   createInvoice,
//   getBase64FromImageUrl,
//   getInvoicesNumber,
// } from "../Services/InvoicePageService";
// import Footer from "../Footer/Footer";
// import Select, { SingleValue } from "react-select";
// import {
//   convertINRToWords,
//   generateBaseInvoicePDF,
//   getStateCode,
//   sanitizeValue,
// } from "../Services/CommonService";
// import { getItems } from "../Services/inventoryService";
// import {
//   IInvoiceFormData,
//   InvoiceItem,
//   ICustomer,
// } from "../Interfaces/IInvoice";
// import Swal from "sweetalert2";
// import { Discount } from "@mui/icons-material";
// import { Container, Box, CircularProgress } from "@mui/material";
// import { generateReceipt } from "../Services/InvoiceReceiptService";

// const InvoiceForm: React.FC = () => {
//   const [items, setItems] = useState<
//     {
//       value: string;
//       label: string;
//       price: number;
//       discount: number;
//       tax: number;
//       hsn: string;
//       quantity: number;
//     }[]
//   >([]);
//   const [showNewCustomerPopup, setShowNewCustomerPopup] = useState(false);
//   const [showNewSalespersonPopup, setShowNewSalespersonPopup] = useState(false);
//   const [customers, setCustomers] = useState<
//     {
//       id: string;
//       name: string;
//       email: string;
//       phone: string;
//       GSTIN: string;
//       street: string;
//       city: string;
//       state: string;
//       zipCode: string;
//       country: string;
//       companyName: string;
//     }[]
//   >([]);
//   const [selectedCustomerById, setSelectedCustomerById] =
//     useState<ICustomer | null>(null);
//   const [salesperson, setSalesperson] = useState<string[]>([]);
//   const [includeShipping, setIncludeShipping] = useState(false);
//   const [shippingCharge, setShippingCharge] = useState<number>(0);
//   const [invoiceItems, setInvoiceItems] = useState<InvoiceItem[]>([
//     {
//       itemId: "",
//       description: "",
//       quantity: 1,
//       rate: 1,
//       discount: 0,
//       tax: 0,
//       amount: 0,
//       hsn: "",
//     },
//   ]);
//   const [selectedCustomer, setSelectedCustomer] = useState<{
//     id: string;
//     name: string;
//   } | null>(null);
//   const [selectedSalesperson, setSelectedSalesperson] = useState<string>("");
//   const [orgDetails, setOrgDetails] = useState<any>(null);
//   const [saving, setSaving] = useState(false);
//   const [receivedAmount,setReceivedAmount]=useState<number>(0);
//   const orgId = localStorage.getItem("orgId") ?? "";

//   const handleAddCustomer = (newCustomer: any) => {
//     const newCustomerObject = {
//       id: newCustomer.customerId,
//       //name: `${newCustomer.salutation || ""} ${newCustomer.firstName || ""} ${newCustomer.lastName || ""}-${newCustomer?.companyName || ""}`,
//       name:
//         newCustomer?.customerName ??
//         (newCustomer?.companyName ||
//           [newCustomer?.firstName, newCustomer?.lastName]
//             .filter(Boolean)
//             .join(" ")),
//       email: `${newCustomer.email || ""}`,
//       phone: `${newCustomer.phone || ""}`,
//       GSTIN: `${newCustomer.GSTIN || ""}`,
//       street: `${newCustomer.address?.street || ""}`,
//       city: `${newCustomer.address?.city || ""}`,
//       state: `${newCustomer.address?.state || ""}`,
//       zipCode: `${newCustomer.address?.zipCode || ""}`,
//       country: `${newCustomer.address?.country || ""}`,
//       companyName: `${newCustomer?.companyName || ""}`,
//     };
//     setCustomers((prev) => [...prev, newCustomerObject]);
//     setSelectedCustomer(newCustomerObject);
//     setSelectedCustomerById(newCustomerObject);
//   };
//   const handleAddSalesPerson = (newSalesperson: any) => {
//     setSalesperson((prev) => [
//       ...prev,
//       `${newSalesperson.salutation} ${newSalesperson.firstName} ${newSalesperson.lastName}`,
//     ]);
//     setSelectedSalesperson(
//       `${newSalesperson.salutation} ${newSalesperson.firstName} ${newSalesperson.lastName}`
//     );
//   };
//   const fetchInvoiceNumber = async () => {
//     try {
//       const latestInvoiceNumber = await getInvoicesNumber(orgId);
//       setFormData((prev) => ({
//         ...prev,
//         invoiceNumber: latestInvoiceNumber,
//       }));
//     } catch (error) {
//       console.error("Failed to fetch the latest invoice number", error);
//     }
//   };
//   const [itemsKey, setItemsKey] = useState(0);
//   const loadItems = async () => {
//     try {
//       const itemData = await getItems(orgId);
//       const formattedItems = itemData.map((item: any) => ({
//         value: item.itemId,
//         label: `${item.name} ${item.desc || ""}`,
//         price: item.sellingPrice,
//         discount: 0,
//         tax: 0,
//         hsn: item.hsn,
//         quantity: item.quantity,
//       }));
//       setItems(formattedItems);
//       setItemsKey((prev) => prev + 1); // ✅ Change key to force re-render
//     } catch (error) {
//       console.error("Error loading items:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Failed to load items",
//         text: "Please try again.",
//       });
//     }
//   };
//   useEffect(() => {
//     const loadCustomers = async () => {
//       try {
//         const customerData = await getUsers(orgId, "customer");
//         const customersList = customerData?.map((customer: any) => ({
//           id: customer.Id,
//           //name: `${customer?.salutation || "" } ${customer?.firstName || ""} ${customer?.lastName || ""}-${customer?.companyName || ""}`,
//           //name: customer?.customerName ?? `${customer?.companyName || customer?.firstName +" "+customer?.lastName}`,
//           name:
//             customer?.customerName ??
//             (customer?.companyName ||
//               [customer?.firstName, customer?.lastName]
//                 .filter(Boolean)
//                 .join(" ")),
//           email: `${customer?.email || ""}`,
//           GSTIN: `${customer?.GSTIN || ""}`,
//           phone: `${customer?.phone || ""}`,
//           street: `${customer?.address?.street || ""}`,
//           city: `${customer?.address?.city || ""}`,
//           state: `${customer?.address?.state || ""}`,
//           zipCode: `${customer?.address?.zipCode || ""}`,
//           country: `${customer?.address?.country || ""}`,
//           companyName: `${customer?.companyName || ""}`,
//         }));
//         setCustomers(customersList);

//       let salePersonNames: string[] = [];
//        try {
//         const salepersonData = await getUsers(orgId, "salesPerson");
//          salePersonNames = salepersonData?.map(
//           (saleperson: any) =>
//             saleperson.salutation +
//             " " +
//             saleperson.firstName +
//             " " +
//             saleperson.lastName
//         )|| [];
//         } catch (err) {
//         // If no salesperson found, just keep empty list
//         console.warn("No salesperson found for this org.");
//       }
//         setSalesperson(salePersonNames);
//         const orgData = await getOrganizationDetails(orgId);
//         setOrgDetails(orgData);
//       } catch (error) {
//         Swal.fire({
//           icon: "error",
//           title: "Failed to load data.\n" + error,
//           text: "Please try again.",
//         });
//       }
//     };
//     loadItems();
//     fetchInvoiceNumber();
//     loadCustomers();
//   }, []);

//   const [formData, setFormData] = useState<IInvoiceFormData>({
//     customerName: "",
//     invoiceNumber: "",
//     orderNumber: "",
//     invoiceDate: new Date().toISOString(),
//     terms: "",
//     dueDate: new Date().toISOString(),
//     salesPerson: "",
//     paymentMode: "",
//     buyerOrderDate: new Date().toISOString(),
//   });

//   const handleFormChange = (
//     e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
//   ) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleAddNewItem = () => {
//     setInvoiceItems([
//       ...invoiceItems,
//       {
//         itemId: "",
//         description: "",
//         quantity: 1,
//         rate: 0,
//         discount: 0,
//         tax: 0,
//         amount: 0,
//         hsn: "",
//       },
//     ]);
//   };
//   const handleRemoveItem = (index: number) => {
//     const updatedItems = [...invoiceItems];
//     updatedItems.splice(index, 1);
//     setInvoiceItems(updatedItems);
//   };
//   const handleItemChange = (index: number, name: string, value: any) => {
//     const updatedItems = [...invoiceItems];
//     const selectedItem = items.find(
//       (item) => item.value === updatedItems[index].itemId
//     ); // Find the selected item
//     const enteredVal = Number(value);
//     if (name === "quantity") {
//       // Allow empty input so the user can type a new number
//       if (value === "") {
//         updatedItems[index] = { ...updatedItems[index], [name]: value };
//         setInvoiceItems(updatedItems);
//         return;
//       }
//       //const enteredQuantity = Number(value);
//       // 🔸 Check if the input is a valid number and greater than zero
//       if (isNaN(enteredVal) || enteredVal <= 0) {
//         Swal.fire({
//           icon: "warning",
//           title: "Invalid Quantity",
//           text: "Please enter a valid quantity greater than zero.",
//         });
//         return; // Stop further execution
//       }
//       if (selectedItem && enteredVal > selectedItem?.quantity) {
//         // Assuming `stock` is the available stock property
//         Swal.fire({
//           icon: "error",
//           title: "Invalid Quantity",
//           text: `Quantity must be less than or equal to ${selectedItem.quantity} for item ${selectedItem.label}.`,
//         });
//         return; // Stop further execution
//       }
//     }
//     if (name === "rate") {
//       // Allow empty input so the user can type a new number
//       if (value === "") {
//         updatedItems[index] = { ...updatedItems[index], [name]: value };
//         setInvoiceItems(updatedItems);
//         return;
//       }
//       // 🔸 Check if the input is a valid number and greater than zero
//       if (isNaN(enteredVal) || enteredVal <= 0) {
//         Swal.fire({
//           icon: "warning",
//           title: "Invalid Rate",
//           text: "Please enter a valid Rate greater than zero.",
//         });
//         return; // Stop further execution
//       }
//     }
//     // Update the invoice items if validation passes
//     updatedItems[index] = { ...updatedItems[index], [name]: value };
//     setInvoiceItems(updatedItems);
//   };
//   const handleItemSelect = (index: number, selectedOption: any) => {
//     const updatedItems = [...invoiceItems];
//     updatedItems[index] = {
//       ...updatedItems[index],
//       description: selectedOption.label,
//       itemId: selectedOption.value,
//       rate: selectedOption.price,
//       discount: selectedOption.discount,
//       tax: selectedOption.tax,
//       hsn: selectedOption.hsn,
//     };
//     setInvoiceItems(updatedItems);
//   };
//   const handleGeneratePDF = async () => {
//     // Step 1: Validate Invoice Data
//     if (!selectedCustomer) {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Please select a customer before saving the invoice.",
//       });
//       return;
//     }
//     // Validate salesperson
//     if (!selectedSalesperson) {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Please select a salesperson before saving the invoice.",
//       });
//       return;
//     }
//     // Validate item rate and quantity
//     for (const item of invoiceItems) {
//       if (item.rate <= 0) {
//         Swal.fire({
//           icon: "warning",
//           title: "Invalid Rate",
//           text: "Rate cannot be negative.",
//         });
//         return;
//       }
//       if (item.quantity <= 0) {
//         Swal.fire({
//           icon: "warning",
//           title: "Invalid Quantity",
//           text: "Quantity must be greater than zero.",
//         });
//         return;
//       }
//     }
//     if (invoiceItems.length === 0 || invoiceItems[0].description === "") {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Please add at least one item to the invoice.",
//       });
//       return;
//     }
//     const invoiceData = {
//       orgId,
//       invoiceId: formData.invoiceNumber,
//       customerId: selectedCustomerById?.id ?? "",
//       orderId: formData.orderNumber || "",
//       orderDate: new Date(formData.buyerOrderDate).toISOString(),//formData.buyerOrderDate || "",
//       salesPersonId: "SP001", // Replace with the actual salesperson ID if available
//       invoiceDate: new Date(formData.invoiceDate).toISOString(),
//       dueDate: new Date(formData.dueDate).toISOString(),
//       salesPersonName: selectedSalesperson,
//       customerName:
//         selectedCustomerById?.name ?? selectedCustomerById?.companyName,
//       terms: formData.terms,
//       totalTax: totalGST,
//       totalDiscount: discTotal,
//       subTotalAmount: subTotal,
//       shippingCharge: includeShipping ? shippingCharge : 0,
//       grandTotal: total,
//       totalPaidAmount: receivedAmount || 0,
//       buyerStateCode: buyerStateCode,
//       sellerStateCode: sellerStateCode,
//       isIntraState: isIntraState,
//       totalCGST: totalCGST,
//       totalSGST: totalSGST,
//       buyerGST: selectedCustomerById?.GSTIN || "",
//       sellerGST: orgDetails?.GST || "",
//       paymentMode: formData.paymentMode,
//       status: Number(receivedAmount) > 0 && Number(receivedAmount) >= Number(total) ? "paid" : "due",
//       invoiceType: "Original",
//       createdBy: "AdminUser ",
//       createdIp: "192.168.1.1",
//       itemDetails: invoiceItems.map((item) => ({
//         itemId: item.itemId,
//         itemDesc: item.description,
//         qty: item.quantity,
//         price: item.rate,
//         discount: item.discount,
//         Tax: item.tax,
//         hsn: item.hsn,
//         amount: parseFloat(
//           (
//             item.quantity *
//             item.rate *
//             (1 - item.discount / 100) *
//             (1 + item.tax / 100)
//           ).toFixed(2)
//         ),
//         taxType: "GST", // Replace with dynamic value if applicable
//       })),
//     };
//     if (true) {
//       try {
//         setSaving(true);
//         //Save Invoice data
//         const saveResponse = await createInvoice(invoiceData);
//         let receiptGenerated = false;
//         if (receivedAmount > 0) {
//           try {
//             await generateReceipt({
//             referenceId: formData.invoiceNumber,
//             referenceType:"Invoice",
//             orgId: orgId,
//             customerName:
//               selectedCustomerById?.name ??
//               selectedCustomerById?.companyName ??
//               "",
//             customerId: selectedCustomerById?.id ?? "",
//             paidAmount: receivedAmount || 0,
//             paymentMode: formData.paymentMode || "",
//             createdBy: "AdminUser",
//           });
//             receiptGenerated = true;
//           } catch (err) {
//             console.error("Receipt generation failed:", err);
//             Swal.fire({
//               icon: "warning",
//               title: "Partial Success",
//               text: "Invoice saved, but receipt generation failed.",
//             });
//           }
//         }
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: receiptGenerated
//             ? "Invoice saved & receipt generated successfully"
//             : "Invoice saved successfully",
//         });
//         generateBaseInvoicePDF(
//           orgDetails,
//           formData,
//           selectedCustomerById,
//           invoiceItems,
//           subTotal,
//           totalCGST,
//           totalSGST,
//           totalGST,
//           discTotal,
//           includeShipping,
//           shippingCharge,
//           total,
//           isIntraState,
//           buyerStateCode,
//           sellerStateCode,
//           taxSummary
//         );
//         // Refresh the invoice number and items
//         setFormData((prev) => ({
//           ...prev,
//           invoiceNumber: "", // This will be updated when fetchInvoiceNumber() runs
//           orderNumber: "",
//           invoiceDate: new Date().toISOString().split("T")[0], // Reset to today's date
//           dueDate: new Date().toISOString().split("T")[0],
//           terms: "Due on receipt",
//           buyerOrderDate: new Date().toISOString().split("T")[0],
//           paymentMode: "",
//         }));
//         await fetchInvoiceNumber();
//         // Clear the selected items and reset form
//         setInvoiceItems([
//           {
//             itemId: "",
//             description: "",
//             quantity: 1,
//             rate: 1,
//             discount: 0,
//             tax: 0,
//             amount: 1,
//             hsn: "",
//           },
//         ]);
//         await loadItems();
//         setSelectedCustomer(null);
//         setSelectedSalesperson("");
//         setShippingCharge(0);
//         setReceivedAmount(0);
//       } catch (error: any) {
//         Swal.fire({
//           icon: "error",
//           title: "Error",
//           text: `Failed to save invoice: ${error.message}`,
//         });
//       }
//       finally
//       {
//         setSaving(false);
//       }
//     }
//   };
//   //End PDF generation

//   const customerOptions = [
//     {
//       value: "addNewCustomer",
//       label: "+ Add New Customer",
//     },
//     ...customers?.map((customer) => ({
//       value: customer.id,
//       label: customer.name,
//     })),
//   ];
//   const handleCustomerChange = (selectedOption: {
//     value: string;
//     label: string;
//   }) => {
//     if (!selectedOption) return;

//     const value = selectedOption.value;

//     if (value === "addNewCustomer") {
//       setShowNewCustomerPopup(true);
//     } else {
//       const selected = customers.find((customer) => customer.id === value);
//       if (selected) {
//         setSelectedCustomerById(selected);
//         setSelectedCustomer(selected);
//       } else {
//         console.error("Selected customer not found");
//       }
//     }
//   };
//   const salespersonOptions = salesperson?.map((sp) => ({
//     value: sp,
//     label: sp,
//   }));

//   // Add "Add New Sales Person" option
//   salespersonOptions.push({
//     value: "addNewSalesperson",
//     label: "+ Add New Sales Person",
//   });

//   const handleSalespersonChange = (
//     selectedOption: SingleValue<{ value: string; label: string }>
//   ) => {
//     if (selectedOption?.value === "addNewSalesperson") {
//       setShowNewSalespersonPopup(true);
//     } else {
//       setSelectedSalesperson(selectedOption?.value || ""); // Handle null case
//     }
//   };

//   // Calculate Subtotal
//   const subTotal = invoiceItems.reduce(
//     (acc, item) => acc + Number(item.quantity) * Number(item.rate),
//     0
//   );
//   //Calculate total Disc
//   const discTotal = invoiceItems.reduce(
//     (acc, item) =>
//       acc +
//       (Number(item.quantity) * Number(item.rate) * Number(item.discount)) / 100,
//     0
//   );
//   // Calculate Total GST
//   const buyerStateCode =
//     selectedCustomerById?.GSTIN.substring(0, 2) ||
//     getStateCode(selectedCustomerById?.state);
//   const sellerStateCode =
//     orgDetails?.GST?.substring(0, 2) ||
//     getStateCode(orgDetails?.address[0]?.state);
//   const isIntraState = buyerStateCode === sellerStateCode;

//   const totalGST = invoiceItems.reduce((acc, item) => {
//     const qty = Number(item.quantity);
//     const rate = Number(item.rate);
//     const discount = Number(item.discount);
//     const tax = Number(item.tax);
//     const discountedAmount = qty * rate * (1 - discount / 100);
//     const gstAmount = (discountedAmount * tax) / 100;
//     return acc + gstAmount;
//   }, 0);
//   //Tax summary by tax slab
//   type TaxSlab = "3" | "5" | "12" | "18" | "28";

//   const taxSummary: Record<TaxSlab, number> = {
//     "3": 0,
//     "5": 0,
//     "12": 0,
//     "18": 0,
//     "28": 0,
//   };

//   // invoiceItems.forEach(item => {
//   //   const discountedAmount = item.quantity * item.rate * (1 - item.discount / 100);
//   //   const gstRate = item.tax.toString() as TaxSlab; // safely cast

//   //   if (gstRate in taxSummary) {
//   //     taxSummary[gstRate] += (discountedAmount * item.tax) / 100;
//   //   }
//   // });
//   invoiceItems.forEach((item) => {
//     const qty = Number(item.quantity);
//     const rate = Number(item.rate);
//     const discount = Number(item.discount);
//     const tax = Number(item.tax);
//     const discountedAmount = qty * rate * (1 - discount / 100);
//     const gstAmount = (discountedAmount * tax) / 100;
//     const taxKey = tax.toString() as TaxSlab;
//     if (taxKey in taxSummary) {
//       taxSummary[taxKey] += gstAmount;
//     }
//   });
//   // Determine CGST and SGST if it's an intra-state transaction
//   let totalCGST = 0;
//   let totalSGST = 0;
//   if (buyerStateCode === sellerStateCode) {
//     totalCGST = totalGST / 2;
//     totalSGST = totalGST / 2;
//   }
//   // Calculate total (including GST and shipping charge)
//   const total =
//     invoiceItems.reduce((acc, item) => {
//       const qty = Number(item.quantity);
//       const rate = Number(item.rate);
//       const discount = Number(item.discount);
//       const tax = Number(item.tax);
//       const itemTotal = qty * rate * (1 - discount / 100) * (1 + tax / 100);
//       return acc + itemTotal;
//     }, 0) + (includeShipping ? shippingCharge : 0);
//   return (
//     <>
//       <div className="page-location">
//         <span>Sales &gt; New Invoice</span>
//       </div>
//       <Container maxWidth="lg" sx={{ padding: 1 }}>
//         {/* <h2 className="form-title">New Invoice</h2> */}
//         <form className="invoice-form">
//           <div className="form-group">
//             <label>
//               Customer Name<span style={{ color: "red" }}>*</span>:
//             </label>
//             <Select
//               options={customerOptions}
//               value={
//                 customerOptions.find(
//                   (option) => option.value === selectedCustomer?.id
//                 ) || null
//               }
//               onChange={(selectedOption) =>
//                 selectedOption && handleCustomerChange(selectedOption)
//               }
//               className="form-input"
//               placeholder="Select Customer"
//               isSearchable
//               required
//             />
//           </div>
//           <div className="form-group">
//             <label>
//               Invoice Number<span style={{ color: "red" }}>*</span>:
//             </label>
//             <input
//               type="text"
//               name="invoiceNumber"
//               className="form-input"
//               value={formData.invoiceNumber}
//               readOnly
//               required
//             />
//           </div>
//           <div className="form-group">
//             <label>
//               Invoice Date<span style={{ color: "red" }}>*</span>:
//             </label>
//             <input
//               type="date"
//               name="invoiceDate"
//               className="form-input"
//               value={formData.invoiceDate.split("T")[0]} // Format date for input
//               onChange={handleFormChange}
//               required
//             />
//           </div>
//           <div className="form-group">
//             <label>Buyer's Order No.:</label>
//             <input
//               type="text"
//               name="orderNumber"
//               value={formData.orderNumber}
//               className="form-input"
//               min={0}
//               step={1}
//               onChange={(e) => {
//                 const value = Number(e.target.value);
//                 if (value < 0 || e.target.value.includes("-")) {
//                   Swal.fire({
//                     icon: "warning",
//                     title: "Invalid Order Number",
//                     text: "Order number should be greater than or equalto 0 and should not have (-) sign",
//                   }).then(() => {
//                     (e.target as HTMLInputElement).value = "0";
//                   });
//                 } else {
//                   handleFormChange(e);
//                 }
//               }}
//               onKeyDown={(e) => {
//                 if (e.key === "-") {
//                   e.preventDefault();
//                 }
//               }}
//             />
//           </div>
//           <div className="form-group">
//             <label>Buyer's Order Date:</label>
//             <input
//               type="date"
//               name="buyerOrderDate"
//               className="form-input"
//               value={formData?.buyerOrderDate?.split("T")[0] || ""}
//               onChange={handleFormChange}
//               required
//             />
//           </div>
//           <div className="form-group">
//             <label>Terms:</label>
//             <select
//               name="terms"
//               className="form-input"
//               onChange={handleFormChange}
//             >
//               <option value="due_on_receipt">Due on receipt</option>
//               <option value="net_30">Net 30</option>
//               <option value="net_60">Net 60</option>
//               <option value="cod">COD</option>
//               <option value="eom">EOM</option>
//               <option value="pia_cia">PIA/CIA</option>
//             </select>
//           </div>
//           <div className="form-group">
//             <label>
//               Due Date<span style={{ color: "red" }}>*</span>:
//             </label>
//             <input
//               type="date"
//               name="dueDate"
//               className="form-input"
//               value={formData.dueDate.split("T")[0]} // Format date for input
//               onChange={handleFormChange}
//               required
//             />
//           </div>
//           <div className="form-group">
//             <label>Mode/Terms of Payment:</label>
//             <select
//               name="paymentMode"
//               className="form-input"
//               value={formData.paymentMode}
//               onChange={handleFormChange}
//               required
//             >
//               <option value="">Select Mode of Payment</option>
//               <option value="CASH">Cash</option>
//               <option value="CHEQUE">Cheque</option>
//               <option value="UPI">UPI</option>
//               <option value="BANK_TRANSFER">Bank Transfer</option>
//               <option value="NET_BANKING">Net Banking</option>
//               <option value="CREDIT">Credit</option>
//             </select>
//           </div>
//           <div className="form-group">
//             <label>
//               Sales Person<span style={{ color: "red" }}>*</span>:
//             </label>
//             <Select
//               options={salespersonOptions}
//               value={
//                 salespersonOptions.find(
//                   (option) => option.value === selectedSalesperson
//                 ) || null
//               }
//               onChange={handleSalespersonChange}
//               className="form-input"
//               placeholder="Select Sales Person"
//               isSearchable
//               required
//             />
//           </div>
//         </form>
//         {/* Item Details Container */}
//         <div className="invoice-items-container">
//           <h3 className="section-title">Item Details</h3>
//           {invoiceItems.map((item, index) => (
//             <div key={index} className="item-row">
//               <div className="item-fields">
//                 <label>
//                   Item Name<span style={{ color: "red" }}>*</span>:
//                   <Select
//                     className="input-hsn"
//                     key={itemsKey} // ✅ Forces re-render
//                     options={items}
//                     value={items.find((option) => option.value === item.itemId)}
//                     onChange={(selectedOption) =>
//                       handleItemSelect(index, selectedOption)
//                     }
//                     placeholder="Select Item"
//                     isSearchable
//                     styles={{
//                       container: (base) => ({
//                         ...base,
//                         width: "350px",
//                       }),
//                     }}
//                   />
//                 </label>
//                 <label>
//                   HSN:
//                   <input
//                     type="text"
//                     placeholder="HSN"
//                     className="item-input"
//                     value={item.hsn}
//                     onChange={(e) => {
//                       handleItemChange(index, "hsn", e.target.value);
//                     }}
//                   />
//                 </label>
//                 <label>
//                   Quantity<span style={{ color: "red" }}>*</span>:
//                   <input
//                     type="number"
//                     placeholder="Quantity"
//                     className="item-input"
//                     value={item.quantity}
//                     onChange={(e) => {
//                       handleItemChange(index, "quantity", e.target.value);
//                     }}
//                   />
//                 </label>
//                 <label>
//                   Rate<span style={{ color: "red" }}>*</span>:
//                   <input
//                     type="number"
//                     placeholder="Rate"
//                     className="item-input"
//                     value={item.rate}
//                     onChange={(e) => {
//                       handleItemChange(index, "rate", e.target.value);
//                     }}
//                   />
//                 </label>
//                 <label>
//                   Discount:
//                   <select
//                     className="item-input"
//                     value={item.discount}
//                     onChange={(e) =>
//                       handleItemChange(
//                         index,
//                         "discount",
//                         Number(e.target.value)
//                       )
//                     }
//                   >
//                     <option value="0">No Discount</option>
//                     <option value="5">5%</option>
//                     <option value="10">10%</option>
//                     <option value="15">15%</option>
//                     <option value="20">20%</option>
//                   </select>
//                 </label>
//                 <label>
//                   Tax:
//                   <select
//                     className="item-input"
//                     value={item.tax}
//                     onChange={(e) =>
//                       handleItemChange(index, "tax", Number(e.target.value))
//                     }
//                   >
//                     <option value="0">Tax Not Applicable</option>
//                     <option value="3">3%</option>
//                     <option value="5">5%</option>
//                     <option value="12">12%</option>
//                     <option value="18">18%</option>
//                     <option value="28">28%</option>
//                   </select>
//                 </label>
//                 <label>
//                   Tax Amount:
//                   <input
//                     type="text"
//                     className="item-input"
//                     value={
//                       item.quantity && item.rate
//                         ? (
//                             item.quantity *
//                             item.rate *
//                             (1 - item.discount / 100) *
//                             (item.tax / 100)
//                           ).toFixed(2)
//                         : "0.00"
//                     }
//                     readOnly
//                   />
//                 </label>
//                 <label>
//                   Total:
//                   <input
//                     type="text"
//                     className="item-input"
//                     value={(
//                       item.quantity *
//                       item.rate *
//                       (1 - item.discount / 100) *
//                       (1 + item.tax / 100)
//                     ).toFixed(2)}
//                     readOnly
//                   />
//                 </label>
//               </div>
//               <img
//                 src="/icons8-delete-94.png"
//                 alt="Remove"
//                 className="remove-button"
//                 onClick={() => handleRemoveItem(index)}
//               />
//             </div>
//           ))}
//           <button
//             type="button"
//             className="add-item-button"
//             onClick={handleAddNewItem}
//           >
//             + Add New Item
//           </button>
//           <div className="totalprice">
//             <div className="form-subtotal">
//               <label>Sub Total</label>
//               {/* <span className="form-output">{subTotal.toFixed(2)}</span> */}
//               <span className="form-output">
//                 Rs.
//                 {subTotal.toLocaleString("en-IN", {
//                   minimumFractionDigits: 2,
//                   maximumFractionDigits: 2,
//                 })}
//               </span>
//             </div>
//             {isIntraState ? (
//               <>
//                 <div className="form-IGST">
//                   <label>CGST</label>
//                   {/* <span className="form-output">{ totalCGST?.toFixed(2)}</span> */}
//                   <span className="form-output">
//                     Rs.
//                     {totalCGST?.toLocaleString("en-IN", {
//                       minimumFractionDigits: 2,
//                       maximumFractionDigits: 2,
//                     })}
//                   </span>
//                 </div>
//                 <div className="form-SGST">
//                   <label>SGST</label>
//                   {/* <span className="form-output">{totalSGST.toFixed(2)}</span> */}
//                   <span className="form-output">
//                     Rs.
//                     {totalSGST?.toLocaleString("en-IN", {
//                       minimumFractionDigits: 2,
//                       maximumFractionDigits: 2,
//                     })}
//                   </span>
//                 </div>
//               </>
//             ) : (
//               <div className="form-IGST">
//                 <label>IGST</label>
//                 {/* <span className="form-output">{totalGST.toFixed(2)}</span> */}
//                 <span className="form-output">
//                   Rs.
//                   {totalGST?.toLocaleString("en-IN", {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2,
//                   })}
//                 </span>
//               </div>
//             )}

//             <div className="shipping-charge">
//               <label className="shipping-label">
//                 <input
//                   type="checkbox"
//                   checked={includeShipping}
//                   onChange={(e) => setIncludeShipping(e.target.checked)}
//                 />
//                 Include Shipping Charge
//               </label>
//               {includeShipping && (
//                 <input
//                   type="text"
//                   className="shipping-input"
//                   placeholder="Enter Shipping Charge"
//                   value={shippingCharge}
//                   onChange={(e) => {
//                     const numericValue = Number(e.target.value.trim());
//                     // Prevent negative numbers
//                     if (isNaN(numericValue) || numericValue < 0) {
//                       Swal.fire({
//                         icon: "warning",
//                         title: "Invalid Shipping Charge",
//                         text: "Shipping charge must be greater than or equal to zero.",
//                       });
//                       return;
//                     }
//                     setShippingCharge(numericValue);
//                   }}
//                 />
//               )}
//             </div>
//             <div className="form-total">
//               <label>Total</label>
//               <span className="form-output">
//                 Rs.
//                 {total.toLocaleString("en-IN", {
//                   minimumFractionDigits: 2,
//                   maximumFractionDigits: 2,
//                 })}
//               </span>
//             </div>
//             <div>
//                <label>
//                   Received Amount<span style={{ color: "red" }}>*</span>:
//                 </label>
//                 <input
//                   type="text"
//                   className="form-input"
//                   placeholder="Enter Received Amount"
//                   value={receivedAmount}
//                   onChange={(e) => {
//                     const numericValue = Number(e.target.value.trim());
//                     // Prevent negative numbers
//                     if (isNaN(numericValue) || numericValue < 0) {
//                       Swal.fire({
//                         icon: "warning",
//                         title: "Invalid  Received Amount",
//                         text: " Received Amount must be greater than or equal to zero.",
//                       });
//                       return;
//                     }
//                     setReceivedAmount(numericValue);
//                   }}
//                 />
//             </div>
//             <div className="form-total">
//               <label>Amount in words</label>
//               <label className="form-output">
//           {convertINRToWords(Number(total.toFixed(2)))}
//               </label>
//             </div>
//           </div>
//           <button
//             type="button"
//             className="generate-button"
//           onClick={handleGeneratePDF}
//           disabled={saving}
//         >
//           {/* {saving ? "Saving..." : "Save"} */}
//           {saving ? <CircularProgress size={20} color="inherit" /> : "Save & Generate Invoice"}
//         </button>
//         </div>
//         {/* Popups for adding new customer and salesperson */}
//         {showNewCustomerPopup && (
//           <AddCustomerPopup
//             type="customer"
//             orgId={orgId}
//             onSave={handleAddCustomer}
//             onClose={() => setShowNewCustomerPopup(false)}
//           />
//         )}
//         {showNewSalespersonPopup && (
//           <AddCustomerPopup
//             type="salesPerson"
//             orgId={orgId}
//             onSave={handleAddSalesPerson}
//             onClose={() => setShowNewSalespersonPopup(false)}
//           />
//         )}
//       </Container>
//       <Box
//         sx={{
//           position: "relative",
//           left: 0,
//           bottom: 0,
//           width: "100%",
//           mt: 10,
//         }}
//       >
//         <Footer />
//       </Box>
//     </>
//   );
// };
// export default InvoiceForm;
import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import AddCustomerPopup from "./AddCustomerPopup";
import "../Style/InvoiceForm.css";
import "../Style/Common.css";
import "../Style/AddCustomerPopup.css";
import { getUsers } from "../Services/userService";
import { getOrganizationDetails } from "../Services/orgService";
import {
  createInvoice,
  getBase64FromImageUrl,
  getInvoicesNumber,
} from "../Services/InvoicePageService";
import Footer from "../Footer/Footer";
import Select, { SingleValue } from "react-select";
import {
  convertINRToWords,
  generateNewInvoicePDF,
  getStateCode,
  sanitizeValue,
} from "../Services/CommonService";
import { getItems } from "../Services/inventoryService";
import {
  IInvoiceFormData,
  InvoiceItem,
  ICustomer,
} from "../Interfaces/IInvoice";
import Swal from "sweetalert2";
import { Discount } from "@mui/icons-material";
import {
  Container,
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Stack,
  TextField,
  Typography,
  Button,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import DownloadIcon from "@mui/icons-material/Download";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { generateReceipt } from "../Services/InvoiceReceiptService";
import {
  shareInvoicePdf,
  buildInvoiceWhatsAppMessage,
} from "../Services/shareInvoiceOnWhatsApp";
import { useSubscription } from "../Hooks/useSubscription";
// ── Step 5/6/7 note ─────────────────────────────────────────────────────────
// TaxSlab type is re-declared locally here to match the one used by
// generateBaseInvoicePDF / taxSummary. If it's already exported from
// CommonService.ts or IInvoice.ts elsewhere in your project, import it from
// there instead of redeclaring, to avoid two separate type definitions.
type TaxSlab = "3" | "5" | "12" | "18" | "28";

const InvoiceForm: React.FC = () => {
  const [items, setItems] = useState<
    {
      value: string;
      label: string;
      price: number;
      discount: number;
      tax: number;
      hsn: string;
      quantity: number;
      uom: string; // Step 7: unit carried from inventory item
    }[]
  >([]);
  const [showNewCustomerPopup, setShowNewCustomerPopup] = useState(false);
  const [showNewSalespersonPopup, setShowNewSalespersonPopup] = useState(false);
  const [customers, setCustomers] = useState<
    {
      id: string;
      name: string;
      email: string;
      phone: string;
      GSTIN: string;
      street: string;
      city: string;
      state: string;
      zipCode: string;
      country: string;
      companyName: string;
    }[]
  >([]);
  const [selectedCustomerById, setSelectedCustomerById] =
    useState<ICustomer | null>(null);
  const [salesperson, setSalesperson] = useState<string[]>([]);
  const [includeShipping, setIncludeShipping] = useState(false);
  const [shippingCharge, setShippingCharge] = useState<number>(0);
  const [invoiceItems, setInvoiceItems] = useState<InvoiceItem[]>([
    {
      itemId: "",
      description: "",
      quantity: 1,
      rate: 1,
      discount: 0,
      tax: 0,
      amount: 0,
      hsn: "",
      uom: "",
    },
  ]);
  const [selectedCustomer, setSelectedCustomer] = useState<{
    id: string;
    name: string;
  } | null>(null);
  const [selectedSalesperson, setSelectedSalesperson] = useState<string>("");
  const [orgDetails, setOrgDetails] = useState<any>(null);
  const [saving, setSaving] = useState(false);
  const [receivedAmount, setReceivedAmount] = useState<number>(0);
  const [receivedAmountTouched, setReceivedAmountTouched] = useState(false);
  const orgId = localStorage.getItem("orgId") ?? "";
  const discPercentOptions = Array.from({ length: 101 }, (_, i) => i);
  const { canCreateInvoice, refreshSubscription, isExpired, invoiceUsage, plan } = useSubscription();
  // Step 4: Print / Download / WhatsApp preview dialog state
  const [previewOpen, setPreviewOpen] = useState(false);
  const [savedPdfArgs, setSavedPdfArgs] = useState<any>(null);
  const [waPhone, setWaPhone] = useState("");
  const [waStatus, setWaStatus] = useState<string | null>(null);
  const [busy, setBusy] = useState<"" | "print" | "download" | "whatsapp">("");
  const [roundOff, setRoundOff] = useState<number>(0);
  const handleAddCustomer = (newCustomer: any) => {
    const newCustomerObject = {
      id: newCustomer.customerId,
      name:
        newCustomer?.customerName ??
        (newCustomer?.companyName ||
          [newCustomer?.firstName, newCustomer?.lastName]
            .filter(Boolean)
            .join(" ")),
      email: `${newCustomer.email || ""}`,
      phone: `${newCustomer.phone || ""}`,
      GSTIN: `${newCustomer.GSTIN || ""}`,
      street: `${newCustomer.address?.street || ""}`,
      city: `${newCustomer.address?.city || ""}`,
      state: `${newCustomer.address?.state || ""}`,
      zipCode: `${newCustomer.address?.zipCode || ""}`,
      country: `${newCustomer.address?.country || ""}`,
      companyName: `${newCustomer?.companyName || ""}`,
    };
    setCustomers((prev) => [...prev, newCustomerObject]);
    setSelectedCustomer(newCustomerObject);
    setSelectedCustomerById(newCustomerObject);
  };
  const handleAddSalesPerson = (newSalesperson: any) => {
    setSalesperson((prev) => [
      ...prev,
      `${newSalesperson.salutation} ${newSalesperson.firstName} ${newSalesperson.lastName}`,
    ]);
    setSelectedSalesperson(
      `${newSalesperson.salutation} ${newSalesperson.firstName} ${newSalesperson.lastName}`
    );
  };
  const fetchInvoiceNumber = async () => {
    try {
      const latestInvoiceNumber = await getInvoicesNumber(orgId);
      setFormData((prev) => ({
        ...prev,
        invoiceNumber: latestInvoiceNumber,
      }));
    } catch (error) {
      console.error("Failed to fetch the latest invoice number", error);
    }
  };
  const [itemsKey, setItemsKey] = useState(0);
  const loadItems = async () => {
    try {
      const itemData = await getItems(orgId);
      const formattedItems = itemData.map((item: any) => ({
        value: item.itemId,
        label: `${item.name} ${item.desc || ""}`,
        price: item.sellingPrice,
        discount: 0,
        tax: 0,
        hsn: item.hsn,
        quantity: item.quantity,
        uom: item.uom || "", // Step 7: carry unit through from inventory
      }));
      setItems(formattedItems);
      setItemsKey((prev) => prev + 1);
    } catch (error) {
      console.error("Error loading items:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to load items",
        text: "Please try again.",
      });
    }
  };
  useEffect(() => {
    const loadCustomers = async () => {
      try {
        const customerData = await getUsers(orgId, "customer");
        const customersList = customerData?.map((customer: any) => ({
          id: customer.Id,
          name:
            customer?.customerName ??
            (customer?.companyName ||
              [customer?.firstName, customer?.lastName]
                .filter(Boolean)
                .join(" ")),
          email: `${customer?.email || ""}`,
          GSTIN: `${customer?.GSTIN || ""}`,
          phone: `${customer?.phone || ""}`,
          street: `${customer?.address?.street || ""}`,
          city: `${customer?.address?.city || ""}`,
          state: `${customer?.address?.state || ""}`,
          zipCode: `${customer?.address?.zipCode || ""}`,
          country: `${customer?.address?.country || ""}`,
          companyName: `${customer?.companyName || ""}`,
        }));
        setCustomers(customersList);

        let salePersonNames: string[] = [];
        try {
          const salepersonData = await getUsers(orgId, "salesPerson");
          salePersonNames =
            salepersonData?.map(
              (saleperson: any) =>
                saleperson.salutation +
                " " +
                saleperson.firstName +
                " " +
                saleperson.lastName
            ) || [];
        } catch (err) {
          console.warn("No salesperson found for this org.");
        }
        setSalesperson(salePersonNames);
        const orgData = await getOrganizationDetails(orgId);
        setOrgDetails(orgData);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Failed to load data.\n" + error,
          text: "Please try again.",
        });
      }
    };
    loadItems();
    fetchInvoiceNumber();
    loadCustomers();
  }, []);

  const [formData, setFormData] = useState<IInvoiceFormData>({
    customerName: "",
    invoiceNumber: "",
    orderNumber: "",
    invoiceDate: new Date().toISOString(),
    terms: "",
    dueDate: new Date().toISOString(),
    salesPerson: "",
    paymentMode: "",
    buyerOrderDate: new Date().toISOString(),
  });

  const handleFormChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddNewItem = () => {
    setInvoiceItems([
      ...invoiceItems,
      {
        itemId: "",
        description: "",
        quantity: 1,
        rate: 0,
        discount: 0,
        tax: 0,
        amount: 0,
        hsn: "",
        uom: "",
      },
    ]);
  };
  const handleRemoveItem = (index: number) => {
    const updatedItems = [...invoiceItems];
    updatedItems.splice(index, 1);
    setInvoiceItems(updatedItems);
  };
  const handleItemChange = (index: number, name: string, value: any) => {
    const updatedItems = [...invoiceItems];
    const selectedItem = items.find(
      (item) => item.value === updatedItems[index].itemId
    );
    const enteredVal = Number(value);
    if (name === "quantity") {
      if (value === "") {
        updatedItems[index] = { ...updatedItems[index], [name]: value };
        setInvoiceItems(updatedItems);
        return;
      }
      if (isNaN(enteredVal) || enteredVal <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Quantity",
          text: "Please enter a valid quantity greater than zero.",
        });
        return;
      }
      if (selectedItem && enteredVal > selectedItem?.quantity) {
        Swal.fire({
          icon: "error",
          title: "Invalid Quantity",
          text: `Quantity must be less than or equal to ${selectedItem.quantity} for item ${selectedItem.label}.`,
        });
        return;
      }
    }
    if (name === "rate") {
      if (value === "") {
        updatedItems[index] = { ...updatedItems[index], [name]: value };
        setInvoiceItems(updatedItems);
        return;
      }
      if (isNaN(enteredVal) || enteredVal <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Rate",
          text: "Please enter a valid Rate greater than zero.",
        });
        return;
      }
    }
    updatedItems[index] = { ...updatedItems[index], [name]: value };
    setInvoiceItems(updatedItems);
  };
  const handleItemSelect = (index: number, selectedOption: any) => {
    const updatedItems = [...invoiceItems];
    updatedItems[index] = {
      ...updatedItems[index],
      description: selectedOption.label,
      itemId: selectedOption.value,
      rate: selectedOption.price,
      discount: selectedOption.discount,
      tax: selectedOption.tax,
      hsn: selectedOption.hsn,
      uom: selectedOption.uom, // Step 7: carry unit onto the line item
    };
    setInvoiceItems(updatedItems);
  };

  const handleGeneratePDF = async () => {
    if (!selectedCustomer) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select a customer before saving the invoice.",
      });
      return;
    }
    if (!selectedSalesperson) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select a salesperson before saving the invoice.",
      });
      return;
    }
    for (const item of invoiceItems) {
      if (item.rate <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Rate",
          text: "Rate cannot be negative.",
        });
        return;
      }
      if (item.quantity <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Quantity",
          text: "Quantity must be greater than zero.",
        });
        return;
      }
    }
    if (invoiceItems.length === 0 || invoiceItems[0].description === "") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please add at least one item to the invoice.",
      });
      return;
    }
    const invoiceData = {
      orgId,
      invoiceId: formData.invoiceNumber,
      customerId: selectedCustomerById?.id ?? "",
      orderId: formData.orderNumber || "",
      orderDate: new Date(formData.buyerOrderDate).toISOString(),
      salesPersonId: "SP001",
      invoiceDate: new Date(formData.invoiceDate).toISOString(),
      dueDate: new Date(formData.dueDate).toISOString(),
      salesPersonName: selectedSalesperson,
      customerName:
        selectedCustomerById?.name ?? selectedCustomerById?.companyName,
      terms: formData.terms,
      totalTax: totalGST,
      totalDiscount: discTotal,
      subTotalAmount: subTotal,
      shippingCharge: includeShipping ? shippingCharge : 0,
      roundOff: Number(roundOff || 0),
      grandTotal: total,
      totalPaidAmount: receivedAmount || 0,
      buyerStateCode: buyerStateCode,
      sellerStateCode: sellerStateCode,
      isIntraState: isIntraState,
      totalCGST: totalCGST,
      totalSGST: totalSGST,
      buyerGST: selectedCustomerById?.GSTIN || "",
      sellerGST: orgDetails?.GST || "",
      paymentMode: formData.paymentMode,
      status:
        Number(receivedAmount) > 0 && Number(receivedAmount) >= Number(total)
          ? "paid"
          : "due",
      invoiceType: "Original",
      createdBy: "AdminUser ",
      createdIp: "192.168.1.1",
      itemDetails: invoiceItems.map((item) => ({
        itemId: item.itemId,
        itemDesc: item.description,
        qty: item.quantity,
        price: item.rate,
        discount: item.discount,
        Tax: item.tax,
        hsn: item.hsn,
        amount: parseFloat(
          (
            item.quantity *
            item.rate *
            (1 - item.discount / 100) *
            (1 + item.tax / 100)
          ).toFixed(2)
        ),
        taxType: "GST",
      })),
    };
    if (true) {
      try {
        setSaving(true);
        const saveResponse = await createInvoice(invoiceData);
        await refreshSubscription();
        let receiptGenerated = false;
        if (receivedAmount > 0) {
          try {
            await generateReceipt({
              referenceId: formData.invoiceNumber,
              referenceType: "Invoice",
              orgId: orgId,
              customerName:
                selectedCustomerById?.name ??
                selectedCustomerById?.companyName ??
                "",
              customerId: selectedCustomerById?.id ?? "",
              paidAmount: receivedAmount || 0,
              paymentMode: formData.paymentMode || "",
              createdBy: "AdminUser",
            });
            receiptGenerated = true;
          } catch (err) {
            console.error("Receipt generation failed:", err);
            Swal.fire({
              icon: "warning",
              title: "Partial Success",
              text: "Invoice saved, but receipt generation failed.",
            });
          }
        }

        // Step 4: snapshot everything generateBaseInvoicePDF needs BEFORE
        // the form resets below, then open the preview dialog instead of
        // auto-downloading the PDF straight away.
        setSavedPdfArgs({
          orgDetails,
          formData: { ...formData },
          customer: selectedCustomerById,
          items: [...invoiceItems],
          subTotal,
          totalCGST,
          totalSGST,
          totalGST,
          discTotal,
          includeShipping,
          shippingCharge,
          total,
          isIntraState,
          buyerStateCode,
          sellerStateCode,
          taxSummary: { ...taxSummary },
          roundOff: roundOff,
        });
        setWaPhone(selectedCustomerById?.phone ?? "");
        setWaStatus(null);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: receiptGenerated
            ? "Invoice saved & receipt generated successfully"
            : "Invoice saved successfully",
        }).then(() => {
          setPreviewOpen(true);
        });

        setFormData((prev) => ({
          ...prev,
          invoiceNumber: "",
          orderNumber: "",
          invoiceDate: new Date().toISOString().split("T")[0],
          dueDate: new Date().toISOString().split("T")[0],
          terms: "Due on receipt",
          buyerOrderDate: new Date().toISOString().split("T")[0],
          paymentMode: "",
        }));
        await fetchInvoiceNumber();
        setInvoiceItems([
          {
            itemId: "",
            description: "",
            quantity: 1,
            rate: 1,
            discount: 0,
            tax: 0,
            amount: 1,
            hsn: "",
            uom: "",
          },
        ]);
        await loadItems();
        setSelectedCustomer(null);
        setSelectedCustomerById(null);
        setSelectedSalesperson("");
        setShippingCharge(0);
        setReceivedAmount(0);
        setReceivedAmountTouched(false);
        setRoundOff(0);
      } catch (error: any) {
        const code = error?.response?.data?.code;
        const data = error?.response?.data?.data;

        const messagesByCode: Record<string, string> = {
          SUBSCRIPTION_EXPIRED: "Your subscription has expired. Please renew your plan.",
          INVOICE_LIMIT_REACHED: `You have reached your invoice limit (${data?.used ?? "?"} / ${data?.limit ?? "?"}). Please upgrade your plan.`,
          FEATURE_NOT_AVAILABLE: "Invoicing is not available on your current plan.",
          SUBSCRIPTION_NOT_FOUND: "No active subscription was found for your organization.",
          SUBSCRIPTION_INACTIVE: "Your subscription is not currently active.",
        };

        Swal.fire({
          icon: "error",
          title: "Error",
          text: code && messagesByCode[code] ? messagesByCode[code] : `Failed to save invoice: ${error.message}`,
        });
      } finally {
        setSaving(false);
      }
    }
  };
  //End PDF generation

  // Step 4: Print / Download / WhatsApp — all three reuse generateBaseInvoicePDF
  const callPdf = (mode: "download" | "print" | "blob") => {
    if (!savedPdfArgs) return null;
    const a = savedPdfArgs;
    return generateNewInvoicePDF(
      a.orgDetails,
      a.formData,
      a.customer,
      a.items,
      a.subTotal,
      a.totalCGST,
      a.totalSGST,
      a.totalGST,
      a.discTotal,
      a.includeShipping,
      a.shippingCharge,
      a.total,
      a.isIntraState,
      a.buyerStateCode,
      a.sellerStateCode,
      a.taxSummary,
      mode,
      a.roundOff,
    );
  };

  const confirmPrint = async () => {
    setBusy("print");
    try {
      callPdf("print");
    } catch (error: any) {
      Swal.fire({ icon: "error", title: "Print failed", text: error.message });
    } finally {
      setBusy("");
    }
  };

  const confirmDownload = async () => {
    setBusy("download");
    try {
      callPdf("download");
    } catch (error: any) {
      Swal.fire({ icon: "error", title: "Download failed", text: error.message });
    } finally {
      setBusy("");
    }
  };

  const confirmWhatsAppShare = async () => {
    if (!savedPdfArgs) return;
    if (!waPhone.trim()) {
      setWaStatus("Enter the customer's WhatsApp number first.");
      return;
    }
    setBusy("whatsapp");
    setWaStatus(null);
    try {
      const blob = callPdf("blob") as Blob;
      const message = buildInvoiceWhatsAppMessage(
        savedPdfArgs.formData.invoiceNumber,
        savedPdfArgs.customer?.name ?? savedPdfArgs.customer?.companyName ?? "",
        savedPdfArgs.total
      );
      const result = await shareInvoicePdf(
        blob,
        `Invoice_${savedPdfArgs.formData.invoiceNumber}.pdf`,
        waPhone,
        message
      );
      if (result.method === "web-share") {
        setWaStatus("Shared via WhatsApp ✅");
      } else if (result.method === "manual-attach") {
        setWaStatus(
          "PDF downloaded and WhatsApp chat opened — drag the PDF into the chat to send it."
        );
      }
    } catch (error: any) {
      setWaStatus("Could not prepare the PDF for sharing.");
    } finally {
      setBusy("");
    }
  };

  const customerOptions = [
    {
      value: "addNewCustomer",
      label: "+ Add New Customer",
    },
    ...customers?.map((customer) => ({
      value: customer.id,
      label: customer.name,
    })),
  ];
  const handleCustomerChange = (selectedOption: {
    value: string;
    label: string;
  }) => {
    if (!selectedOption) return;

    const value = selectedOption.value;

    if (value === "addNewCustomer") {
      setShowNewCustomerPopup(true);
    } else {
      const selected = customers.find((customer) => customer.id === value);
      if (selected) {
        setSelectedCustomerById(selected);
        setSelectedCustomer(selected);
      } else {
        console.error("Selected customer not found");
      }
    }
  };
  const salespersonOptions = salesperson?.map((sp) => ({
    value: sp,
    label: sp,
  }));

  salespersonOptions.push({
    value: "addNewSalesperson",
    label: "+ Add New Sales Person",
  });

  const handleSalespersonChange = (
    selectedOption: SingleValue<{ value: string; label: string }>
  ) => {
    if (selectedOption?.value === "addNewSalesperson") {
      setShowNewSalespersonPopup(true);
    } else {
      setSelectedSalesperson(selectedOption?.value || "");
    }
  };

  const subTotal = invoiceItems.reduce(
    (acc, item) => acc + Number(item.quantity) * Number(item.rate),
    0
  );
  const discTotal = invoiceItems.reduce(
    (acc, item) =>
      acc +
      (Number(item.quantity) * Number(item.rate) * Number(item.discount)) /
      100,
    0
  );
  const buyerStateCode =
    selectedCustomerById?.GSTIN.substring(0, 2) ||
    getStateCode(selectedCustomerById?.state);
  const sellerStateCode =
    orgDetails?.GST?.substring(0, 2) ||
    getStateCode(orgDetails?.address[0]?.state);
  const isIntraState = buyerStateCode === sellerStateCode;

  const totalGST = invoiceItems.reduce((acc, item) => {
    const qty = Number(item.quantity);
    const rate = Number(item.rate);
    const discount = Number(item.discount);
    const tax = Number(item.tax);
    const discountedAmount = qty * rate * (1 - discount / 100);
    const gstAmount = (discountedAmount * tax) / 100;
    return acc + gstAmount;
  }, 0);
  const taxSummary: Record<TaxSlab, number> = {
    "3": 0,
    "5": 0,
    "12": 0,
    "18": 0,
    "28": 0,
  };

  invoiceItems.forEach((item) => {
    const qty = Number(item.quantity);
    const rate = Number(item.rate);
    const discount = Number(item.discount);
    const tax = Number(item.tax);
    const discountedAmount = qty * rate * (1 - discount / 100);
    const gstAmount = (discountedAmount * tax) / 100;
    const taxKey = tax.toString() as TaxSlab;
    if (taxKey in taxSummary) {
      taxSummary[taxKey] += gstAmount;
    }
  });
  let totalCGST = 0;
  let totalSGST = 0;
  if (buyerStateCode === sellerStateCode) {
    totalCGST = totalGST / 2;
    totalSGST = totalGST / 2;
  }
  const calculatedTotal =
    invoiceItems.reduce((acc, item) => {
      const qty = Number(item.quantity);
      const rate = Number(item.rate);
      const discount = Number(item.discount);
      const tax = Number(item.tax);
      const itemTotal = qty * rate * (1 - discount / 100) * (1 + tax / 100);
      return acc + itemTotal;
    }, 0) + (includeShipping ? shippingCharge : 0);

  // Final Grand Total
  const total = Number(
    (calculatedTotal + Number(roundOff || 0)).toFixed(2)
  );
   useEffect(() => {
    if (!receivedAmountTouched) {
      setReceivedAmount(total);
    }
  }, [total, receivedAmountTouched]);
  return (
    <>
      <div className="page-location">
        <span>Sales &gt; New Invoice</span>
      </div>
      <Container maxWidth="lg" sx={{ padding: 1 }}>
        <form className="invoice-form">
          <div className="form-group">
            <label>
              Customer Name<span style={{ color: "red" }}>*</span>:
            </label>
            <Select
              options={customerOptions}
              value={
                customerOptions.find(
                  (option) => option.value === selectedCustomer?.id
                ) || null
              }
              onChange={(selectedOption) =>
                selectedOption && handleCustomerChange(selectedOption)
              }
              className="form-input"
              placeholder="Select Customer"
              isSearchable
              required
            />
            {/* Step 1 & 2: customer info shown right below the dropdown,
                purely informational, no layout change, wraps on mobile via CSS. */}
            {selectedCustomerById && (
              <div className="customer-info-label">
                {selectedCustomerById.name}
                {selectedCustomerById.GSTIN
                  ? `  •  GST: ${selectedCustomerById.GSTIN}`
                  : ""}
                {selectedCustomerById.state
                  ? `  •  ${selectedCustomerById.state}`
                  : ""}
              </div>
            )}
          </div>
          <div className="form-group">
            <label>
              Invoice Number<span style={{ color: "red" }}>*</span>:
            </label>
            <input
              type="text"
              name="invoiceNumber"
              className="form-input"
              value={formData.invoiceNumber}
              readOnly
              required
            />
          </div>
          <div className="form-group">
            <label>
              Invoice Date<span style={{ color: "red" }}>*</span>:
            </label>
            <input
              type="date"
              name="invoiceDate"
              className="form-input"
              value={formData.invoiceDate.split("T")[0]}
              onChange={handleFormChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Buyer's Order No.:</label>
            <input
              type="text"
              name="orderNumber"
              value={formData.orderNumber}
              className="form-input"
              min={0}
              step={1}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value < 0 || e.target.value.includes("-")) {
                  Swal.fire({
                    icon: "warning",
                    title: "Invalid Order Number",
                    text: "Order number should be greater than or equalto 0 and should not have (-) sign",
                  }).then(() => {
                    (e.target as HTMLInputElement).value = "0";
                  });
                } else {
                  handleFormChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "-") {
                  e.preventDefault();
                }
              }}
            />
          </div>
          <div className="form-group">
            <label>Buyer's Order Date:</label>
            <input
              type="date"
              name="buyerOrderDate"
              className="form-input"
              value={formData?.buyerOrderDate?.split("T")[0] || ""}
              onChange={handleFormChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Terms:</label>
            <select
              name="terms"
              className="form-input"
              onChange={handleFormChange}
            >
              <option value="due_on_receipt">Due on receipt</option>
              <option value="net_30">Net 30</option>
              <option value="net_60">Net 60</option>
              <option value="cod">COD</option>
              <option value="eom">EOM</option>
              <option value="pia_cia">PIA/CIA</option>
            </select>
          </div>
          <div className="form-group">
            <label>
              Due Date<span style={{ color: "red" }}>*</span>:
            </label>
            <input
              type="date"
              name="dueDate"
              className="form-input"
              value={formData.dueDate.split("T")[0]}
              onChange={handleFormChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Mode/Terms of Payment:</label>
            <select
              name="paymentMode"
              className="form-input"
              value={formData.paymentMode}
              onChange={handleFormChange}
              required
            >
              <option value="">Select Mode of Payment</option>
              <option value="CASH">Cash</option>
              <option value="CHEQUE">Cheque</option>
              <option value="UPI">UPI</option>
              <option value="BANK_TRANSFER">Bank Transfer</option>
              <option value="NET_BANKING">Net Banking</option>
              <option value="CREDIT">Credit</option>
            </select>
          </div>
          <div className="form-group">
            <label>
              Sales Person<span style={{ color: "red" }}>*</span>:
            </label>
            <Select
              options={salespersonOptions}
              value={
                salespersonOptions.find(
                  (option) => option.value === selectedSalesperson
                ) || null
              }
              onChange={handleSalespersonChange}
              className="form-input"
              placeholder="Select Sales Person"
              isSearchable
              required
            />
          </div>
        </form>
        {/* Item Details Container */}
        <div className="invoice-items-container">
          <h3 className="section-title">Item Details</h3>
          {invoiceItems.map((item, index) => (
            <div key={index} className="item-row">
              <div className="item-fields">
                <label>
                  Item Name<span style={{ color: "red" }}>*</span>:
                  <Select
                    className="input-hsn"
                    key={itemsKey}
                    options={items}
                    value={items.find((option) => option.value === item.itemId)}
                    onChange={(selectedOption) =>
                      handleItemSelect(index, selectedOption)
                    }
                    placeholder="Select Item"
                    isSearchable
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: "350px",
                      }),
                    }}
                  />
                </label>
                <label>
                  HSN:
                  <input
                    type="text"
                    placeholder="HSN"
                    className="item-input"
                    value={item.hsn}
                    onChange={(e) => {
                      handleItemChange(index, "hsn", e.target.value);
                    }}
                  />
                </label>
                <label>
                  Quantity<span style={{ color: "red" }}>*</span>:
                  <input
                    type="number"
                    placeholder="Quantity"
                    className="item-input"
                    value={item.quantity}
                    onChange={(e) => {
                      handleItemChange(index, "quantity", e.target.value);
                    }}
                  />
                </label>
                <label>
                  Rate<span style={{ color: "red" }}>*</span>:
                  <input
                    type="number"
                    placeholder="Rate"
                    className="item-input"
                    value={item.rate}
                    onChange={(e) => {
                      handleItemChange(index, "rate", e.target.value);
                    }}
                  />
                  {/* Step 7: show rate with unit, e.g. 1000/kg */}
                  {item.uom && (
                    <span
                      style={{
                        fontSize: "11px",
                        color: "#666",
                        marginLeft: "4px",
                      }}
                    >
                      /{item.uom}
                    </span>
                  )}
                </label>
                {/* <label>
                  Discount:
                  <select
                    className="item-input"
                    value={item.discount}
                    onChange={(e) =>
                      handleItemChange(
                        index,
                        "discount",
                        Number(e.target.value)
                      )
                    }
                  >
                    <option value="0">No Discount</option>
                    <option value="5">5%</option>
                    <option value="10">10%</option>
                    <option value="15">15%</option>
                    <option value="20">20%</option>
                  </select>
                </label> */}
                <label>
                  Discount (%):
                  <Autocomplete
                    freeSolo
                    disableClearable
                    size="small"
                    sx={{ width: 350 }}
                    options={discPercentOptions.map(String)}
                    inputValue={String(item.discount ?? "")}
                    onInputChange={(_event, newValue, reason) => {
                      if (reason !== "input") return;
                      handleItemChange(index, "discount", newValue);
                    }}
                    onChange={(_event, newValue) => {

                      if (newValue === null) return;
                      const numeric = Number(newValue);
                      handleItemChange(index, "discount", isNaN(numeric) ? 0 : numeric);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="0-100"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "#fff",
                          },
                        }}
                        onBlur={() => {
                          const numeric = Number(item.discount);
                          if (isNaN(numeric)) {
                            handleItemChange(index, "discount", 0);
                            return;
                          }
                          if (numeric < 0 || numeric > 100) {
                            Swal.fire({
                              icon: "warning",
                              title: "Invalid Discount",
                              text: "Discount must be a percentage between 0 and 100.",
                            });
                          }
                          handleItemChange(index, "discount", Math.min(Math.max(numeric, 0), 100));
                        }}
                      />
                    )}
                  />
                </label>
                <label>
                  Tax:
                  <select
                    className="item-input"
                    value={item.tax}
                    onChange={(e) =>
                      handleItemChange(index, "tax", Number(e.target.value))
                    }
                  >
                    <option value="0">Tax Not Applicable</option>
                    <option value="3">3%</option>
                    <option value="5">5%</option>
                    <option value="12">12%</option>
                    <option value="18">18%</option>
                    <option value="28">28%</option>
                  </select>
                </label>
                {/* <label>
                  Discount Amount:
                  <input
                    type="text"
                    className="item-input"
                    value={
                      item.discount > 0 && item.quantity && item.rate
                        ? `Rs.${(
                            item.quantity *
                            item.rate *
                            (item.discount / 100)
                          ).toFixed(2)}`
                        : "No Discount"
                    }
                    readOnly
                  />
                </label> */}
                <label>
                  Tax Amount:
                  <input
                    type="text"
                    className="item-input"
                    value={
                      item.quantity && item.rate
                        ? (
                          item.quantity *
                          item.rate *
                          (1 - item.discount / 100) *
                          (item.tax / 100)
                        ).toFixed(2)
                        : "0.00"
                    }
                    readOnly
                  />
                </label>
                <label>
                  Total:
                  <input
                    type="text"
                    className="item-input"
                    value={(
                      item.quantity *
                      item.rate *
                      (1 - item.discount / 100) *
                      (1 + item.tax / 100)
                    ).toFixed(2)}
                    readOnly
                  />
                </label>
              </div>
              <img
                src="/icons8-delete-94.png"
                alt="Remove"
                className="remove-button"
                onClick={() => handleRemoveItem(index)}
              />
            </div>
          ))}
          <button
            type="button"
            className="add-item-button"
            onClick={handleAddNewItem}
          >
            + Add New Item
          </button>
          <div className="totalprice">
            <div className="form-subtotal">
              <label>Sub Total</label>
              <span className="form-output">
                Rs.
                {subTotal.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
            {isIntraState ? (
              <>
                <div className="form-IGST">
                  <label>CGST</label>
                  <span className="form-output">
                    Rs.
                    {totalCGST?.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
                <div className="form-SGST">
                  <label>SGST</label>
                  <span className="form-output">
                    Rs.
                    {totalSGST?.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
              </>
            ) : (
              <div className="form-IGST">
                <label>IGST</label>
                <span className="form-output">
                  Rs.
                  {totalGST?.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </div>
            )}

            <div className="shipping-charge">
              <label className="shipping-label">
                <input
                  type="checkbox"
                  checked={includeShipping}
                  onChange={(e) => setIncludeShipping(e.target.checked)}
                />
                Include Shipping Charge
              </label>
              {includeShipping && (
                <input
                  type="text"
                  className="shipping-input"
                  placeholder="Enter Shipping Charge"
                  value={shippingCharge}
                  onChange={(e) => {
                    const numericValue = Number(e.target.value.trim());
                    if (isNaN(numericValue) || numericValue < 0) {
                      Swal.fire({
                        icon: "warning",
                        title: "Invalid Shipping Charge",
                        text: "Shipping charge must be greater than or equal to zero.",
                      });
                      return;
                    }
                    setShippingCharge(numericValue);
                  }}
                />
              )}
            </div>
            <div className="form-total">
              <label>Round Off</label>
              <input
                type="number"
                step="0.01"
                value={roundOff}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow empty input
                  if (value === "") {
                    setRoundOff(0);
                    return;
                  }
                  setRoundOff(Number(value));
                }}
                className="form-input"
              />
            </div>

            <div className="form-total">
              <label>Total</label>
              <span className="form-output">
                Rs.
                {total.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
            <div>
              <label>
                Received Amount<span style={{ color: "red" }}>*</span>:
              </label>
              {/* <input
                type="text"
                className="form-input"
                placeholder="Enter Received Amount"
                value={receivedAmount}
                onChange={(e) => {
                  const numericValue = Number(e.target.value.trim());
                  if (isNaN(numericValue) || numericValue < 0) {
                    Swal.fire({
                      icon: "warning",
                      title: "Invalid  Received Amount",
                      text: " Received Amount must be greater than or equal to zero.",
                    });
                    return;
                  }
                  setReceivedAmount(numericValue);
                }}
              /> */}
                            <input
                type="text"
                className="form-input"
                placeholder="Enter Received Amount"
                value={receivedAmount}
                onChange={(e) => {
                  const numericValue = Number(e.target.value.trim());
                  if (isNaN(numericValue) || numericValue < 0) {
                    Swal.fire({
                      icon: "warning",
                      title: "Invalid  Received Amount",
                      text: " Received Amount must be greater than or equal to zero.",
                    });
                    return;
                  }
                  setReceivedAmountTouched(true);
                  setReceivedAmount(numericValue);
                }}
              />
            </div>
            <div className="form-total">
              <label>Amount in words</label>
              <label className="form-output">
                {convertINRToWords(Number(total.toFixed(2)))}
              </label>
            </div>
          </div>
          {!canCreateInvoice && (
            <Typography
              variant="body2"
              color="error"
              sx={{ mt: 1, mb: 1, textAlign: "center" }}
            >
              {isExpired
                ? "Your subscription has expired. Please renew your plan to create more invoices."
                : invoiceUsage && !invoiceUsage.unlimited && (invoiceUsage.remaining ?? 0) <= 0
                  ? `You have reached your invoice limit (${invoiceUsage.used} / ${invoiceUsage.limit}) for your ${plan?.planName ?? "current"} plan. Please upgrade your plan to create more invoices.`
                  : "Invoicing is not available on your current plan. Please upgrade your plan."}
            </Typography>
          )}
          <button
            type="button"
            className="generate-button"
            onClick={handleGeneratePDF}
            disabled={saving || !canCreateInvoice}
            style={
              !saving && !canCreateInvoice
                ? {
                  opacity: 0.5,
                  cursor: "not-allowed",
                  filter: "grayscale(60%)",
                }
                : undefined
            }
          >
            {saving ? <CircularProgress size={20} color="inherit" /> : "Save & Generate Invoice"}
          </button>
        </div>
        {/* Popups for adding new customer and salesperson */}
        {showNewCustomerPopup && (
          <AddCustomerPopup
            type="customer"
            orgId={orgId}
            onSave={handleAddCustomer}
            onClose={() => setShowNewCustomerPopup(false)}
          />
        )}
        {showNewSalespersonPopup && (
          <AddCustomerPopup
            type="salesPerson"
            orgId={orgId}
            onSave={handleAddSalesPerson}
            onClose={() => setShowNewSalespersonPopup(false)}
          />
        )}
      </Container>

      {/* Step 4: Preview -> Print / Download / WhatsApp dialog,
          same model/pattern as ViewInvoiceDetails, backed by generateBaseInvoicePDF */}
      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Invoice Preview
          <IconButton size="small" onClick={() => setPreviewOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {savedPdfArgs && (
            <Box>
              <Typography variant="subtitle1" fontWeight={700}>
                {savedPdfArgs.formData.invoiceNumber}
              </Typography>
              <Typography variant="body2">
                {savedPdfArgs.customer?.name ??
                  savedPdfArgs.customer?.companyName}
              </Typography>
              <Box mt={1}>
                <Typography variant="body2">
                  Subtotal: Rs.{savedPdfArgs.subTotal.toFixed(2)}
                </Typography>
                {savedPdfArgs.isIntraState ? (
                  <>
                    <Typography variant="body2">
                      CGST: Rs.{savedPdfArgs.totalCGST.toFixed(2)}
                    </Typography>
                    <Typography variant="body2">
                      SGST: Rs.{savedPdfArgs.totalSGST.toFixed(2)}
                    </Typography>
                  </>
                ) : (
                  <Typography variant="body2">
                    IGST: Rs.{savedPdfArgs.totalGST.toFixed(2)}
                  </Typography>
                )}
                <Typography variant="subtitle2" fontWeight={700}>
                  Grand Total: Rs.{savedPdfArgs.total.toFixed(2)}
                </Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions
          sx={{ flexDirection: "column", alignItems: "stretch", gap: 1, p: 2 }}
        >
          <Stack direction="row" spacing={1}>
            <TextField
              size="small"
              fullWidth
              label="Customer WhatsApp number"
              value={waPhone}
              onChange={(e) => setWaPhone(e.target.value)}
            />
            <Button
              variant="outlined"
              color="success"
              startIcon={<WhatsAppIcon />}
              disabled={busy !== ""}
              onClick={confirmWhatsAppShare}
            >
              {busy === "whatsapp" ? "Preparing…" : "Share"}
            </Button>
          </Stack>
          {waStatus && (
            <Typography variant="caption" color="text.secondary">
              {waStatus}
            </Typography>
          )}
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button onClick={() => setPreviewOpen(false)}>Close</Button>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              disabled={busy !== ""}
              onClick={confirmDownload}
            >
              {busy === "download" ? "Generating…" : "Download PDF"}
            </Button>
            <Button
              variant="contained"
              startIcon={<PrintIcon />}
              disabled={busy !== ""}
              onClick={confirmPrint}
            >
              Print
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          position: "relative",
          left: 0,
          bottom: 0,
          width: "100%",
          mt: 10,
        }}
      >
        <Footer />
      </Box>
    </>
  );
};
export default InvoiceForm;